module.exports = __webpack_public_path__ + "img/maisui.d5f010bd.svg";